import { DriversSettings } from "@/types/drivesAppSettings"
import { atom } from "recoil"

export const driversSettingsAtom = atom({
  key: "driversSettingsAtom",
  default: {} as DriversSettings,
})
